import React, { ReactNode } from 'react';

interface JobSectionHeadingProps {
  children: ReactNode;
  className?: string;
}

export const JobSectionHeading: React.FC<JobSectionHeadingProps> = ({ 
  children,
  className = ''
}) => {
  return (
    <h3 className={`text-xl font-semibold text-blue-700 mt-8 mb-4 ${className}`}>
      {children}
    </h3>
  );
};
